module.exports = __webpack_public_path__ + "static/media/form.42747dba.svg";